import { Directive, TemplateRef } from '@angular/core';

@Directive({selector: '[appQueryRemoveButton]'})
export class QueryRemoveButtonDirective {
  constructor(public template: TemplateRef<any>) {}
}
